(() => {
  const root = window.Shopify?.routes?.root || '/';

  const parseResponse = async (response) => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
    return data;
  };

  const formatMoney = (cents, currency, locale) =>
    new Intl.NumberFormat(locale || 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);

  const updateBundle = (section) => {
    const selects = [...section.querySelectorAll('[data-bundle-variant]')];
    const quantity = Math.max(1, Number(section.querySelector('[data-bundle-quantity]')?.value || 1));
    const discountReady = section.dataset.discountReady === 'true';
    const discountPercent = Number(section.dataset.discountPercent || 0);
    const factor = discountReady ? (100 - discountPercent) / 100 : 1;
    const currency = section.dataset.currency;
    const locale = section.dataset.locale;
    let originalTotal = 0;

    selects.forEach((select) => {
      const price = Number(select.selectedOptions[0]?.dataset.price || 0);
      originalTotal += price;
      const card = select.closest('.lumbv-product-bundle__card');
      const cardPriceNode = card?.querySelector('[data-card-price]');
      if (cardPriceNode) cardPriceNode.textContent = formatMoney(price, currency, locale);
    });

    const originalNode = section.querySelector('[data-bundle-original-total]');
    const discountedNode = section.querySelector('[data-bundle-discounted-total]');
    if (originalNode) originalNode.textContent = formatMoney(originalTotal * quantity, currency, locale);
    if (discountedNode) discountedNode.textContent = formatMoney(Math.round(originalTotal * factor) * quantity, currency, locale);
  };

  document.addEventListener('change', (event) => {
    const bundle = event.target.closest('[data-lumbv-bundle]');
    if (bundle && (event.target.matches('[data-bundle-variant]') || event.target.matches('[data-bundle-quantity]'))) {
      updateBundle(bundle);
    }
  });

  document.addEventListener('click', async (event) => {
    const bundleButton = event.target.closest('[data-bundle-submit]');
    if (bundleButton) {
      const section = bundleButton.closest('[data-lumbv-bundle]');
      const selects = [...section.querySelectorAll('[data-bundle-variant]')];
      const quantity = Math.max(1, Number(section.querySelector('[data-bundle-quantity]')?.value || 1));
      const status = section.querySelector('[data-bundle-status]');
      const ids = selects.map((select) => Number(select.value));
      if (ids.length !== 2 || ids[0] === ids[1]) {
        if (status) status.textContent = section.dataset.differentProductsLabel;
        return;
      }
      bundleButton.disabled = true;
      bundleButton.setAttribute('aria-busy', 'true');
      bundleButton.textContent = bundleButton.dataset.loadingLabel;
      if (status) status.textContent = '';
      try {
        await parseResponse(
          await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: ids.map((id) => ({
                id,
                quantity,
                properties: { _lumbv_bundle: section.id },
              })),
            }),
          }),
        );
        window.location.assign(`${root}cart`);
      } catch (error) {
        if (status) status.textContent = error.message;
        bundleButton.disabled = false;
        bundleButton.removeAttribute('aria-busy');
        bundleButton.textContent = bundleButton.dataset.idleLabel;
      }
      return;
    }

    const quantityButton = event.target.closest('[data-bundle-quantity-minus], [data-bundle-quantity-plus]');
    if (quantityButton) {
      const section = quantityButton.closest('[data-lumbv-bundle]');
      const input = section.querySelector('[data-bundle-quantity]');
      const change = quantityButton.matches('[data-bundle-quantity-plus]') ? 1 : -1;
      input.value = Math.min(Number(input.max), Math.max(Number(input.min), Number(input.value || 1) + change));
      updateBundle(section);
      return;
    }

    const recommendationButton = event.target.closest('[data-recommendations-direction]');
    if (recommendationButton) {
      const section = recommendationButton.closest('.lumbv-recommendations');
      const track = section?.querySelector('[data-recommendations-track]');
      const card = track?.querySelector('li');
      if (!track || !card) return;
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      const direction = recommendationButton.dataset.recommendationsDirection === 'next' ? 1 : -1;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
  });
})();
